import * as types from './types'
import storage from '@/Plugins/storage'
import globals from '@/Plugins/globals'
import store from '@/Store'

export default {
  [types.SET_PAGER](state, data) {
    switch (data.name) {
      case 'orderBy': {
        state.pager.orderBy = data.value
        break
      }
      case 'sortBy': {
        state.pager.sortBy = data.value
        break
      }
      case 'search': {
        state.pager.search = data.value
        break
      }
      case 'page': {
        state.pager.page = data.value
        break
      }
      case 'pageSize': {
        state.pager.pageSize = data.value
        break
      }
    }
    storage.session.setItem(types.STORE_PAGER, JSON.stringify(state.pager))
  },
  [types.SET_LIBRARYNAME](state, data) {
    console.log('Saving Library Name (dispatch)', data)
    store.dispatch('usercardio/setLibraryName', data)
  },
  [types.SET_CHALLENGENAME](state, data) {
    console.log('Saving Challenge Name (dispatch)', data)
    store.dispatch('usercardio/setChallengeName', data)
  },
  [types.SET_DASHBOARDNAME](state, data) {
    console.log('Saving Dashboard Name (dispatch)', data)
    store.dispatch('usercardio/setDashboardName', data)
  },
  [types.EXAMINE_ORGANIZATION](state, data) {
    storage.session.setItem(types.STORE_EXAMINE_ORG, JSON.stringify(data))
    state.examineOrganization = data
  },
  [types.RESET_ORGANIZATION](state) {
    state.organization = JSON.parse(JSON.stringify(state.default))
  },
  [types.SET_CHECKED](state, data) {
    for (let organization of state.organizations.items) {
      if (organization.name === data.name) {
        organization.isChecked = data.isChecked
      }
    }
    state.isChecked = false
    for (let organization of organizations.users.items) {
      if (organization.isChecked) {
        state.isChecked = true
        break
      }
    }
  },
  [types.SET_TAGS](state, data) {
    state.tags = []
    if (data) {
      state.tags = data
    }
  },
  [types.SET_ORGANIZATIONS](state, data) {
    state.organizations = []
    state.isChecked = false
    if (data !== undefined && data !== null) {
      if (data.data !== undefined && data.data !== null) {
        for (let item of data.data) {
          item.isChecked = false
        }
      }
      state.organizations = data.data
      state.pager.page = data.current_page
      state.pager.pages = data.last_page
      state.pager.total = data.total
    }
  },
  [types.SET_ORGANIZATION](state, data) {
    state.organization = null
    if (data !== undefined && data !== null) {
      state.organization = data
    }
  },
  [types.SET_FOUND_ORGANIZATIONS](state, data) {
    state.found = []
    if (data !== undefined && data !== null) {
      for (let item of data) {
        state.found.push({
          id: item.id,
          name: item.value,
          value: item.id,
        })
      }
    }
  },
  [types.SET_MEMBERS](state, data) {
    state.members = []
    if (data !== undefined && data !== null) {
      state.members = data
    }
  },
  [types.SET_FOUND_MEMBERS](state, data) {
    state.foundMembers = []
    if (data !== undefined && data !== null) {
      for (let item of data) {
        state.foundMembers.push({
          id: item.id,
          name: item.label,
          value: item.value,
        })
      }
    }
    console.log('Found Members', state.foundMembers)
  },
  [types.SORT_MEMBERS](state, sort) {
    if (state.members) {
      state.members = globals.sortArray(state.members, sort.on, sort.dir)
    }
  },
  [types.SET_CHECKED](state, data) {
    for (let organization of state.organizations.items) {
      if (organization.name === data.name) {
        organization.isChecked = data.isChecked
      }
    }
    state.isChecked = false
    for (let organization of state.organizations.items) {
      if (organization.isChecked) {
        state.isChecked = true
        break
      }
    }
  },
  [types.SET_ORGANIZATION_DATA](state, data) {
    switch (data.name) {
      case 'orgCode': {
        state.organization.orgCode = data.value
        break
      }
      case 'orgName': {
        state.organization.orgName = data.value
        break
      }
      case 'isActive': {
        state.organization.isActive = data.value
        break
      }
      case 'address1': {
        state.organization.address1 = data.value
        break
      }
      case 'address2': {
        state.organization.address2 = data.value
        break
      }
      case 'city': {
        state.organization.city = data.value
        break
      }
      case 'state': {
        state.organization.state = data.value
        break
      }
      case 'zipcode': {
        state.organization.zipcode = data.value
        break
      }
      case 'phone': {
        state.organization.phone = data.value
        break
      }
      case 'storeDaysOpen': {
        state.organization.storeDaysOpen = data.value
        break
      }
      case 'storeDaysClose': {
        state.organization.storeDaysClose = data.value
        break
      }
      case 'storeHoursOpen': {
        state.organization.storeHoursOpen = data.value
        break
      }
      case 'storeHoursClose': {
        state.organization.storeHoursClose = data.value
        break
      }
      case 'contactName': {
        state.organization.contactName = data.value
        break
      }
      case 'contactPhone': {
        state.organization.contactPhone = data.value
        break
      }
      case 'contactEmail': {
        state.organization.contactEmail = data.value
        break
      }
      case 'nutritionVisibility': {
        state.organization.nutritionVisibility = data.value
        break
      }
      case 'livestreamVisibility': {
        state.organization.livestreamVisibility = data.value
        break
      }
      case 'coachingVisibility': {
        state.organization.coachingVisibility = data.value
        break
      }
      case 'coachingScheduleUrl': {
        state.organization.coachingScheduleUrl = data.value
        break
      }
      case 'coachwallVisibility': {
        state.organization.coachwallVisibility = data.value
        break
      }
      case 'challengesVisibility': {
        state.organization.challengesVisibility = data.value
        break
      }
      case 'bodyCompositionVisibility': {
        state.organization.bodyCompositionVisibility = data.value
        break
      }
      case 'logourl': {
        state.organization.logourl = data.value
        break
      }
      case 'deeplinkShort': {
        state.organization.deeplinkShort = data.value
        break
      }
      case 'EmailLiveMessage': {
        state.organization.EmailLiveMessage = data.value
        break
      }
      case 'EmailRecapMessage': {
        state.organization.EmailRecapMessage = data.value
        break
      }
      case 'EmailWelcomeMessage': {
        state.organization.EmailWelcomeMessage = data.value
        break
      }
      case 'assessmentVisibility': {
        state.organization.assessmentVisibility = data.value
        break
      }
      case 'progressPhotosVisibility': {
        state.organization.progressPhotosVisibility = data.value
        break
      }
      case 'dashboardVisibility': {
        state.organization.dashboardVisibility = data.value
        break
      }
      case 'IsWelcomeMessage': {
        state.organization.isWelcomeMessage = data.value
        break
      }
      case 'isBatchIntel': {
        state.organization.isBatchIntel = data.value
        break
      }
    }
    console.log('Organization', state.organization)
  },
}
